export const centsToMillicents = num => num * 1000;
export const millicentsToCents = num => Math.floor(num / 1000);
